/**
 * Function to resize Array
 * Appends or delete items to make array length @param length
 */
Array.prototype.resize = function (length, itemToAdd = {}) {
  if (!Number.isInteger(length)) {
    console.error('Length should be Integer');
    return new Error('Length is required');
  }
  while (this.length !== parseInt(length)) {
    if (this.length > parseInt(length)) {
      this.pop();
    } else if (this.length < parseInt(length)) {
      this.push(itemToAdd);
    }
  }
  return this;
};
